import PropTypes from 'prop-types';
import React from 'react';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @param {PropTypes.InferProps<typeof propTypes>} props
 */
const FullBleedVideoModule = ({
    video
}) => {
    return (
        <div className='aspect-[1.1/1] sm:aspect-[1.4/1] md:aspect-[1.7/1] lg:aspect-[2/1]'>

            <video
                autoPlay
                className='w-full h-full object-cover'
                controls={false}
                loop={true}
                muted={true}
                playsInline={true}
                src={video.url} />
        </div>
    );
};

/* ========================================================================= */
/* Typing and export(s) */
/* ========================================================================= */

const propTypes = {
    video: PropTypes.object,
};

FullBleedVideoModule.propTypes = propTypes;

export default FullBleedVideoModule;
